import { MaybeRefOrGetter, toValue } from 'vue';

import { t } from '../../../locale';
import { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  min: MaybeRefOrGetter<number>;
  message?: ValidationMessage;
  trim?: boolean;
}

export default function minLength(config: Config): ValidationRule {
  return {
    name: 'minLength',
    validator(_value) {
      const min = toValue(config.min);
      const value = toValue(_value);

      if (!isDefined(value)) {
        return true;
      }

      let valueString = String(value);

      if (config.trim) {
        valueString = valueString.trim();
      }

      return valueString.length >= min;
    },
    message: config.message || (() => t('ll.validation.minLength', { min: String(toValue(config.min)) })),
  };
}
